import {useEffect} from "react";
import {useLogout} from "./useLogout";
import {useLocalStorage} from "./useLocalStorage";
import {deriveIsSystemAdmin} from "../util/AuthUtil";

export function useCurrentUser(logoutIfNull = false, callback = () => {}) {

  const [currentUser, setCurrentUser] = useLocalStorage("MFE_CURRENT_USER", null);
  const logout = useLogout();

  useEffect(() => {
    if (!currentUser && logoutIfNull) {
      logout();
    }
  }, [currentUser, logoutIfNull]);

    useEffect(() => {
      if (currentUser) {
        callback(currentUser);
      }
    }, [currentUser]);

  const updateCurrentUser = (userOrUpdater) => {
    setCurrentUser((prevUser) => {
      const nextUser = typeof userOrUpdater === "function" ? userOrUpdater(prevUser) : userOrUpdater;
      return deriveIsSystemAdmin(nextUser);
    });
  }

  return [currentUser, updateCurrentUser];
}